import React from 'react';

const SvgArrowDownSmallOutline = props => (
  <svg width={7} height={4} {...props}>
    <path
      d="M3.5 3.188L6.452.098a.311.311 0 0 1 .454 0 .347.347 0 0 1 0 .476L3.727 3.902a.311.311 0 0 1-.454 0L.094.574a.347.347 0 0 1 0-.476.311.311 0 0 1 .454 0L3.5 3.188z"
      fill="#046FE2"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgArrowDownSmallOutline;
